export default () => ({
    member: false,
    nav: false,
    activeGroup: 'events',

    control: {
        ['@click.outside']() {
            this.nav = false
            this.member = false
        },
        ['@keydown.window.escape']() {
            this.nav = false
            this.member = false
        },
    },

    primary: {
        [':class']: 'nav ? "--is-open" : ""',
    },

    sub: {
        [':class']: 'member ? "--is-open" : ""',
    },

    group: {
        [':class']: 'activeGroup == $el.dataset.group ? "--is-active" : ""',
    },

    subNav: {
        ['x-show']: 'activeGroup === $el.dataset.group',
    },

    trigger: {
        [':aria-expanded']: 'nav',
        [':aria-label']: '"toggle element"'
    },

    toggleNav() {
        this.nav = ! this.nav
    },
    toggleMember() {
        this.member = ! this.member
    },
    toggleGroup() {
        this.activeGroup = this.$el.parentElement.dataset.group
    },
})
